// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b3c450ca","239":"035fdde4","453":"4133acb8","455":"ddf5ec75"}[chunkId] + ".chunk.js";
};